<template>
  <div id="ePlace">
    <div style="padding: 0 0.5rem 0.5rem;">
      <b-button variant="primary" tabindex="98"
        @click="save()"><b-icon icon="check"/>&nbsp;{{$t('message.Save_cmd')}}</b-button>&nbsp;&nbsp;
        <b-button tabindex="99"
        @click="remove(inputData.orderno)"><b-icon icon="x"/>&nbsp;{{$t('message.Del_cmd')}}</b-button>&nbsp;&nbsp;
      <b-button tabindex="99"
        @click="close()"><b-icon icon="x"/>&nbsp;{{$t('message.Close_cmd')}}</b-button>
    </div>
    <div class='well'
      style="margin-bottom:0; position: relative; overflow: auto; max-height: 29rem; width: 100%; border-bottom: 1px solid #111; border-top: 1px solid #111;">
      <table style="border:2.5px solid; padding:5px; width:100%;" rules="all" cellpadding='5'
        v-if="null != inputData">
        <tbody style="line-height:1.5rem;">
          <tr style="height:3.5em;">
            <td class="ncut-edit-form-text label-td" style="width:7.5rem;">車位預約單號：</td>
            <td class="ncut-base-form-ipt text-td" style="min-width:7rem;">
              {{0 == id? '系統自動產生': inputData.orderno}}
            </td>
            <td class="ncut-edit-form-text label-td" style="width:7rem;">預約單位：</td>
            <td class="ncut-base-form-ipt text-td" style="min-width:10rem;">
               {{user.deptId}} {{user.dptnm}}

            </td>
            <td class="ncut-edit-form-text label-td" style="width:7rem;">預約人：</td>
            <td class="ncut-base-form-ipt text-td" style="min-width:10rem;">
              {{user.id}} {{user.name}}
            </td>
          </tr>
            <tr style="height:3.5em;">
            <td class="ncut-edit-form-text label-td" style="width:7.5rem;">聯絡分機：</td>
            <td class="ncut-base-form-ipt text-td" style="min-width:7rem;">
             <b-form-input placeholder="請輸入聯絡分機" :maxlength="60" v-model="inputData.ordertel" />
            </td>
            <td class="ncut-edit-form-text label-td" style="width:7rem;">聯絡手機：</td>
            <td class="ncut-base-form-ipt text-td" style="min-width:10rem;">
              <b-form-input placeholder="請輸入聯絡手機" :maxlength="60" v-model="inputData.orderteL2" />

            </td>
            <td class="ncut-edit-form-text label-td" style="width:7rem;">EMAIL</td>
            <td class="ncut-base-form-ipt text-td" style="min-width:10rem;">
<b-form-input placeholder="請輸入EMAIL" :maxlength="60" v-model="inputData.email" />
            </td>
          </tr>
          <tr style="height:3.5em;">
            <td class="ncut-edit-form-text label-td">預約期間：</td>
            <td class="ncut-base-form-ipt text-td" colspan="5">
              <table>
                <tr>
                  <td>
                    <b-form-datepicker v-model="tDate[0]" :max="tDate[1]" locale="zh-TW" tabindex="1"
                      :autofocus="true"
                      :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" disabled></b-form-datepicker>
                  </td>
                  <td>
                    &nbsp;<span style="padding: 0.425rem 0 0;">至</span>&nbsp;
                  </td>
                  <td>
                    <b-form-datepicker v-model="tDate[1]" :min="tDate[0]" locale="zh-TW" tabindex="2"
                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" disabled></b-form-datepicker>
                  </td>
                  <td class="ncut-edit-form-text label-td" style="width:7rem;">租借時段</td>
               <td class="ncut-row-selectd" >
              <select v-model="inputData.ordstime"  @change="onChangeS($event)">
                  <option selected="selected" value="0900">09:00</option>
		<option value="1000">10:00</option>
		<option value="1100">11:00</option>
		<option value="1200">12:00</option>
		<option value="1300">13:00</option>
		<option value="1400">14:00</option>
		<option value="1500">15:00</option>
		<option value="1600">16:00</option>
		<option value="1700">17:00</option>
		<option value="1800">18:00</option>
		<option value="1900">19:00</option>
		<option value="2000">20:00</option>
		<option value="2100">21:00</option>
                  </select>

            </td>~
               <td class="ncut-row-selectd" >
              <select v-model="inputData.ordetime" @change="onChangeE($event)">
                <option selected="selected" value="1000">10:00</option>
		<option value="1100">11:00</option>
		<option value="1200">12:00</option>
		<option value="1300">13:00</option>
		<option value="1400">14:00</option>
		<option value="1500">15:00</option>
		<option value="1600">16:00</option>
		<option value="1700">17:00</option>
		<option value="1800">18:00</option>
		<option value="1900">19:00</option>
		<option value="2000">20:00</option>
		<option value="2100">21:00</option>
		<option value="2200">22:00</option>
                  </select>

            </td>
               <td class="ncut-edit-form-text label-td" style="width:7rem;">車位保留資訊</td>
            <td class="ncut-base-form-ipt text-td" style="min-width:10rem;">
                最大停車數量：{{maxcarnum}}<br>
                已申請停車數量：{{ inputData2.mcarnum }}<br>
              </td>
                </tr>
              </table>
            </td>

          </tr>
          <tr style="height:3.5em;">
            <td class="ncut-edit-form-text label-td" tabindex="3">預約場地：</td>
            <td class="ncut-row-selectd" colspan="3">
              <select v-model="inputData.placeno" disabled>
                  <option value="" selected>請選擇</option>
	                <option value="1110000">青永館前廣場貴賓停車位14格</option>
	                <option value="1211000">行政大樓1F前廣場停車位4格</option>
	                <option value="1611000">圖書資訊館1F前圓環貴賓停車位9格</option>
	                <option value="2000000">後門草皮臨時停車場90格</option>
	                <option value="2100000">前門草皮臨時停車場150格</option>
                  </select>

            </td>
            <td class="ncut-edit-form-text label-td">預約車位數量：</td>
            <td class="ncut-base-form-ipt text-td" >
              <b-form-input placeholder="請輸入預約車位數量" :maxlength="60" tabindex="3"
              @change="getCurrentCarPlace()"
                v-model="inputData.mcarnum" />
            </td>

          </tr>
          <tr style="height:3.5em;">
            <td class="ncut-edit-form-text label-td">申請事由：</td>
            <td class="ncut-base-form-ipt text-td" colspan="5">
              <b-form-textarea type="textarea" placeholder="請輸入預約車位說明" tabindex="4"
                :rows="5"
                v-model="inputData.ordermo"/>
            </td>
          </tr>
           <tr style="height:3.5em;">
            <td class="ncut-edit-form-text label-td">其他需求：</td>
            <td class="ncut-base-form-ipt text-td" colspan="5">
              <b-form-textarea type="textarea" placeholder="請輸入預約車位說明" tabindex="4"
                :rows="5"
                v-model="inputData.otherabs"/>
            </td>
          </tr>
          <template v-if="0 == id?true:false" >
          <tr style="height:3.5em;">
            <td class="ncut-edit-form-text label-td" tabindex="5" >建立日期與時間：</td>
            <td class="ncut-edit-form-text label-td"  >{{ crE_DTE | dateFormatV2   }}</td>
            <td class="ncut-edit-form-text label-td" tabindex="5" >修改日期與時間：</td>
            <td class="ncut-edit-form-text label-td"  >{{ moD_DTE | dateFormatV2   }}</td>

          </tr>
          </template>
            <template v-if="0 != id?true:false" >
          <tr style="height:3.5em;">
            <td class="ncut-edit-form-text label-td" tabindex="5" >建立日期與時間：</td>
            <td class="ncut-edit-form-text label-td"  >{{ inputData.crE_DTE | dateFormatV2    }}</td>
            <td class="ncut-edit-form-text label-td" tabindex="5" >修改日期與時間：</td>
            <td class="ncut-edit-form-text label-td"  >{{ inputData.moD_DTE  | dateFormatV2   }}</td>

          </tr>
          </template>
          <tr>
            <td class="ncut-edit-form-text ">置頂排序：</td>
            <td class="ncut-base-form-ipt" colspan="5" style="padding: 1rem;">
              <b-form-input id="range-1" v-model="inputData.rankKey" type="range" min="0" max="100" tabindex="6"></b-form-input>
              <div class="mt-2">排序：<font size="+1" style="color:#411c35;">{{ inputData.rankKey }}</font>（預設為 0，可決定報表顯示置頂，數字越大順位越高。）</div>
            </td>
          </tr>
          <tr style="height:3.5em;">
            <td class="ncut-edit-form-text label-td">說明：</td>
            <td class="ncut-base-form-ipt text-td" colspan="5">
              <div v-html="memo"/>
            </td>
          </tr>
        </tbody>
      </table>

        <b-modal ref="q-modal" hide-footer title="請注意">
        <div class="d-block text-center">
          <h3>是否確認刪除此筆資料?</h3>
        </div>
        <b-button class="mt-3" variant="outline-danger" block @click="cancalRM">取消刪除</b-button>
        <b-button class="mt-2" variant="outline-info" block @click="confirmRM">刪除確認</b-button>
      </b-modal>
    </div>
  </div>
</template>

<script>
import * as tools from '@/tool'

export default {
  name: 'ePlace',
  props: [
    'id',
    'placeno',
    'selectedDay',
    'date',
    'ordstime',
    'ordetime',
    'maxcarnum'
  ],
  data () {
    return {
      isIE: false,
      inputData: null,
      inputData: { sdate: '' },
      inputData2: {
        mcarnum: 0
      },
      memo: '無',
      crE_DTE: new Date(),
      moD_DTE: new Date(),
      tDate: [null, null]
    }
  },
  computed: {
    sysId () {
      return this.$store.getters.getSysId
    },
    user () {
      return this.$store.getters.getUser
    }
  },
  methods: {
    onChangeS (event) {
      var d = parseInt(event.target.value) + 100
      this.inputData.ordetime = d.toString()
      this.inputData.ordstime = event.target.value.toString()

      var vm = this
      vm.$http.all([vm.getCarPlaceNum()])
        .then(vm.$http.spread(function (response) {
          if (!tools.isNull(response)) { vm.inputData2.mcarnum = response.data } else { vm.inputData2.mcarnum = 0 }

          console.log('vm.inputData2.mcarnum=' + vm.inputData2.mcarnum)
        }))
        .catch(function (error) {
          tools.showAlert(vm, 'danger', '對不起,網路連線失敗' + error)
        })
    },
    onChangeE (event) {
      // var d = parseInt(event.target.value) + 100 ;
      // this.inputData.ordetime=d.toString() ;
      this.inputData.ordetime = event.target.value.toString()

      var vm = this
      vm.$http.all([vm.getCarPlaceNum()])
        .then(vm.$http.spread(function (response) {
          if (!tools.isNull(response)) { vm.inputData2.mcarnum = response.data } else { vm.inputData2.mcarnum = 0 }

          console.log('vm.inputData2.mcarnum=' + vm.inputData2.mcarnum)
        }))
        .catch(function (error) {
          tools.showAlert(vm, 'danger', '對不起,網路連線失敗' + error)
        })
    },
    getCurrentCarPlace () {
      if (this.inputData.mcarnum > (this.maxcarnum)) { alert('預約車位已超出，目前車位尚餘' + (this.maxcarnum - this.inputData2.mcarnum) + '位') }
    },
    setDate (yy, mm, dd) {
      var tYY = parseInt(yy) + 1911
      var tMM = parseInt(mm) - 1
      var tDD = parseInt(dd)
      return new Date(tYY, tMM, tDD)
    },
    getDate (dt) {
      var date = null
      if (dt != null) {
        if (typeof dt === 'string') {
          date = new Date(dt)
        } else {
          date = dt
        }
      }
      var year = date.getFullYear()
      var month = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)
      var day = date.getDate() < 10 ? '0' + date.getDate() : '' + date.getDate()
      return tools.stringFormat('{0}{1}{2}', year - 1911, month, day)
    },
    dateFormatV3: function (input) {
      var d = new Date(input)
      var year = d.getFullYear()
      var month = (d.getMonth() + 1) < 10 ? '0' + (d.getMonth() + 1) : (d.getMonth() + 1)
      var day = d.getDate() < 10 ? '0' + d.getDate() : '' + d.getDate()
      var hh = d.getHours()
      var mm = d.getMinutes()
      var ss = d.getSeconds()
      return tools.stringFormat('{0}-{1}-{2} {3}:{4}:{5}', year, month, day, hh, mm, ss)
    },
    hideModal (event) {
      this.$emit('hideModal')
      this.getDateSet()
    },
    getDateSet () {
      var vm = this
      this.days = []

      this.$http
        .get(
          './WebApi/Place/GetDateSet/'
            .concat(this.sysId)
            .concat('/' + this.placeno)
        )
        .then(function (response) {
          if (!tools.isNull(response.data)) {
            var len = response.data.length
            for (var i = 0; i < len; i++) {
              var tDay = response.data[i]
              vm.days.push({
                orderid: tDay.orderid,
                orderna: tDay.orderna,
                orderno: tDay.orderno,
                orderna: tDay.orderna,
                sdate: tDay.crE_DTE,
                mcarnum: tDay.mcarnum,
                ordstime: tDay.ordstime,
                ordetime: tDay.ordetime
              })
            }
          }
        })
        .catch(function (error) {
          tools.showAlert(vm, 'danger', '對不起,網路連線失敗' + error)
        })
    },
    close () {
      this.$emit('hideModal')
    },
    checkSaveData () {
      let msg = ''

      if (tools.isNullOrEmpty(this.inputData.ordermo)) {
        msg = '貴賓車位預約說明'
      }
      return msg
    },
    remove (id) {
      this.editId = id
      this.$refs['q-modal'].show()
    },
    cancalRM () {
      this.$refs['q-modal'].hide()
    },
    confirmRM () {
      this.$refs['q-modal'].hide()
      var vm = this
      this.$http.get('./WebApi/Place/RemovePlace/'.concat(this.editId))
        .then((response) => {
          if (response.data) {
            tools.showAlert(vm, 'success', '恭喜您,刪除成功')
            this.editId = 0
            this.hideModal()
          } else {
            tools.showAlert(vm, 'danger', '對不起,刪除失敗')
          }
        })
        .catch(function (error) {
          tools.showAlert(vm, 'danger', '網路連線失敗' + error)
        })
    },
    save () {
      var msg = this.checkSaveData()
      var moD_DTE1 = new Date()
      this.inputData.moD_DTE = this.dateFormatV3(moD_DTE1)
      var crE_DTE1 = new Date()
      this.inputData.crE_DTE = this.dateFormatV3(crE_DTE1)
      this.inputData.sysId = this.sysId
      this.inputData.ORDERID = this.user.id
      this.inputData.ORDERNA = this.user.name
      this.inputData.UNIT = this.user.deptId
      this.inputData.UNITNAME = this.user.dptnm
      if (msg.length == 0) {
        const vm = this
        vm.inputData.sysId = vm.sysId
        vm.inputData.userId = vm.user.id
        vm.inputData.sdate = vm.getDate(vm.tDate[0])
        vm.inputData.edate = vm.getDate(vm.tDate[1])

        this.$http.put('./WebApi/Place/SetPlace', vm.inputData)
          .then((response) => {
            if (response.data > 0) {
              tools.showAlert(vm, 'success', '恭喜您,存檔成功')
              vm.mode = 2
              vm.$store.dispatch('actionReSetFlag2', true)
              this.getDateSet()
            } else {
              tools.showAlert(vm, 'danger', '對不起,存檔失敗')
            }
          })
          .catch(function (error) {
            tools.showAlert(vm, 'danger', '對不起,網路連線失敗' + error)
          })
      } else {
        tools.showAlert(this, 'danger', '對不起,請輸入'.concat(msg).concat('!'))
      }
    },
    getPlaceData: function (id) {
      var vm = this
      this.$http.get('./WebApi/Place/GetPlace/'.concat(id))
        .then((response) => {
          if (!tools.isNull(response)) {
            vm.inputData = response.data
            if (tools.isNullOrEmpty(vm.inputData.orderno)) {
              vm.inputData.placeno = vm.placeno
              vm.inputData.ordstime = vm.ordstime
              vm.inputData.ordetime = vm.ordetime
            }

            //     var day = this.selectedDay <10 ? '0' + this.selectedDay : '' + this.selectedDay;
            console.log(this.date.date.getFullYear())
            var yy = this.date.date.getFullYear()
            var yy1 = this.date.date.getFullYear() - 1911
            var mm = ((this.date.date.getMonth()) < 10 ? '0' + (this.date.date.getMonth()) : (this.date.date.getMonth()))
            var mm1 = ((this.date.date.getMonth() + 1) < 10 ? '0' + (this.date.date.getMonth() + 1) : (this.date.date.getMonth() + 1))
            var dd = (this.date.date.getDate() < 10 ? '0' + this.date.date.getDate() : this.date.date.getDate())
            this.inputData.sdate = (yy1).toString() + (mm1).toString() + (dd).toString()
            vm.tDate[0] = new Date(yy, mm, dd)
            vm.tDate[1] = new Date(yy, mm, dd)

            if (vm.inputData.id == 0) {
              var today = new Date()
              var yy = today.getFullYear()
              var mm = today.getMonth()
              var dd = today.getDate()

              vm.inputData.SysId = vm.SysId
              vm.inputData.orderid = vm.user.id
              vm.inputData.ORDERNA = vm.user.name
              vm.inputData.UNIT = vm.user.deptId
              vm.inputData.UNITNAME = vm.user.dptnm
            }

            vm.$http.all([vm.getCarPlaceNum()])
              .then(vm.$http.spread(function (response) {
                if (!tools.isNull(response)) {
                  vm.inputData2.mcarnum = response.data
                }
              }))
          }
        }
        )
        .catch(function (error) {
          tools.showAlert(vm, 'danger', '網路連線失敗' + error)
        })
      return this.$http
        .get('./WebApi/Place/GetPlace/'.concat(id))
    },
    getMemoData: function (id) {
      return this.$http
        .get('./WebApi/Common/GetFormatByNo/'.concat(this.sysId).concat('/1/1'))
    },
    getCarPlaceNum: function () {
      return this.$http
        .get('./WebApi/Place/GetCarPlaceNum/'.concat(this.sysId).concat('/').concat(this.inputData.placeno).concat('/').concat(this.inputData.sdate).concat('/').concat(this.inputData.ordstime).concat('/').concat(this.inputData.ordetime))
    }

  },
  filters: {
    dateFormat: function (input) {
      var d = new Date(input)
      var year = d.getFullYear()
      var month = d.getMonth() + 1
      var day = d.getDate() < 10 ? '0' + d.getDate() : '' + d.getDate()
      return year + '/' + month + '/' + day
    },
    dateFormatV2: function (input) {
      var d = new Date(input)
      var year = d.getFullYear()
      var month = (d.getMonth() + 1) < 10 ? '0' + (d.getMonth() + 1) : (d.getMonth() + 1)
      var day = d.getDate() < 10 ? '0' + d.getDate() : '' + d.getDate()
      var hh = d.getHours()
      var mm = d.getMinutes()
      var ss = d.getSeconds()
      return tools.stringFormat('{0}-{1}-{2} {3}:{4}:{5}', year, month, day, hh, mm, ss)
    }

  },
  created () {
    console.log('======created EditPlaceView =====')
    this.isIE = navigator.userAgent.indexOf('MSIE ') > -1 || navigator.userAgent.indexOf('Trident/') > -1 || navigator.userAgent.indexOf('Edge') > -1

    const vm = this

    this.mode = (this.id == 0 ? 1 : 2)
    this.$http.all([this.getMemoData()])
      .then(vm.$http.spread(function (response) {
        if (!tools.isNull(response)) {
          vm.data = response.data
        }

        vm.getPlaceData(vm.id)
      }))
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
